import { jwtDecode } from 'jwt-decode';
import apiClient from './apiClient';

export const login = async (phone, password) => {
    const response = await apiClient.post(`/auth/basicadminlogin`, { phone, password });

    // API yanıtı: response.data.Data.accessToken
    if (response.data?.Status && response.data?.Data?.accessToken) {
      localStorage.setItem('harmonyadmintoken', response.data.Data.accessToken);

      // Refresh token'ı da saklayalım (opsiyonel)
      if (response.data.Data.refreshToken) {
        localStorage.setItem('harmonyadminrefreshtoken', response.data.Data.refreshToken);
      }

      // User bilgisini de saklayalım
      if (response.data.Data.user) {
        localStorage.setItem('harmonyadminuser', JSON.stringify(response.data.Data.user));
      }
    }

    return response.data;
  };

  export const logout = () => {
    localStorage.removeItem('harmonyadmintoken');
    localStorage.removeItem('harmonyadminrefreshtoken');
    localStorage.removeItem('harmonyadminuser');
  };

  export const getCurrentUser = () => {
    const token = localStorage.getItem('harmonyadmintoken');
    if (!token) return null;

    try {
      const decoded = jwtDecode(token);
      return decoded;
    } catch (error) {
      console.error("JWT Decode Error:", error);
      logout();
      return null;
    }
  };

  export const getStoredUser = () => {
    const userStr = localStorage.getItem('harmonyadminuser');
    if (!userStr) return null;

    try {
      return JSON.parse(userStr);
    } catch {
      return null;
    }
  };

  export const getAccessToken = () => {
    return localStorage.getItem('harmonyadmintoken');
  };

  export const getRefreshToken = () => {
    return localStorage.getItem('harmonyadminrefreshtoken');
  };
